<template>
  <div id="contact">
    <b-container class="container--max-lg">
      <div class="mb-3">
        <h1>{{ $t("lang.label_contact") }}</h1>
      </div>
      <div class="c-dashboard__card">
        <div class="mb-3">
          <router-link class="c-link" to="/dashboard">
            <svg viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.393 19.509L9.464 12l8.929-7.509a.5.5 0 0 0 .06-.704l-1.287-1.531a.5.5 0 0 0-.704-.06L6.168 10.851a1.5 1.5 0 0 0 0 2.296l10.294 8.657a.5.5 0 0 0 .704-.06l1.287-1.532a.5.5 0 0 0-.06-.704z"
                  id="ic-angle-left_svg__a"
                />
              </defs>
              <use fill="currentColor" xlink:href="#ic-angle-left_svg__a" transform="translate(-5 -2)" fill-rule="evenodd" />
            </svg>
            <span>{{ $t("lang.label_back") }}</span></router-link
          >
        </div>
      </div>
      <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
        <b-card>
          <b-card-title class="mb-2">
            {{ $t("lang.label_contact_title") }}
          </b-card-title>
          <b-card-sub-title class="my-3">
            {{ $t("lang.label_contact_subTitle") }}
          </b-card-sub-title>
          <b-form-group>
            <b-form-textarea name="contactMessage" class="mb-4" v-model="contactMessage" type="text" required :placeholder="$t('lang.label_contact_placeholder')" rows="5"> </b-form-textarea>
            <b-form-invalid-feedback>{{ $t("lang.label_placeholder_enterText") }}</b-form-invalid-feedback>
            <div class="mt-2">
              <b-button type="submit" size="lg" variant="primary"> {{ $t("lang.label_contact_send") }}</b-button>
            </div>
          </b-form-group>
        </b-card>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import API from "@/api";

export default {
  name: "Contact",
  data() {
    return {
      wasValidated: false,
      contactMessage: ""
    };
  },
  methods: {
    onSubmit(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasValidated = true;
        return;
      }
      this.sendContactMessage();
    },
    sendContactMessage() {
      try {
        API.contactViaEmail(this.contactMessage);
        this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_user_contact_success"));
        this.$router.push({ name: "dashboard" });
      } catch (ex) {
        this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_contact_error"));
      }
    }
  }
};
</script>

<style scoped></style>
